import { AUTH_CHECK, AUTH_ERROR, AUTH_LOGIN, AUTH_LOGOUT } from 'react-admin';

type ParseAuthConfig = {
    URL?: string;
    'APP-ID'?: string;
    'REST-API-KEY'?: string;
};

const PARSE_TOKEN_KEY = 'parseToken';

export const AuthClient = (parseConfig: ParseAuthConfig) => {
    const manageAuth = (type: string, params: Record<string, unknown>) => {
        const headers = new Headers({
            'Content-Type': 'application/json',
            'X-Parse-Application-Id': parseConfig['APP-ID'] ?? '',
            'X-Parse-REST-API-Key': parseConfig['REST-API-KEY'] ?? '',
        });

        if (type === AUTH_LOGIN) {
            const { username, password, } = params as { username: string; password: string };
            const request = new Request(
                `${parseConfig.URL}/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`,
                {
                    method: 'GET',
                    headers,
                }
            );

            return fetch(request)
                .then((response) => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error(response.statusText);
                    }

                    return response.json();
                })
                .then((response) => {
                    localStorage.setItem(PARSE_TOKEN_KEY, response.sessionToken);
                });
        }

        if (type === AUTH_LOGOUT) {
            const parseToken = localStorage.getItem(PARSE_TOKEN_KEY);

            if (parseToken) {
                headers.set('X-Parse-Session-Token', parseToken);

                const request = new Request(`${parseConfig.URL}/logout`, {
                    method: 'POST',
                    headers,
                });

                return fetch(request).then((response) => {
                    localStorage.removeItem(PARSE_TOKEN_KEY);

                    if (response.status < 200 || response.status >= 300) {
                        return response.json().then((object) => {
                            if (object.code !== 209) {
                                throw new Error(object.error);
                            }
                        });
                    }
                });
            }

            localStorage.removeItem(PARSE_TOKEN_KEY);
            return Promise.resolve();
        }

        if (type === AUTH_ERROR) {
            const { status, } = params as { status?: number };

            if (status === 209) {
                localStorage.removeItem(PARSE_TOKEN_KEY);
                return Promise.reject();
            }

            return Promise.resolve();
        }

        if (type === AUTH_CHECK) {
            return localStorage.getItem(PARSE_TOKEN_KEY) ? Promise.resolve() : Promise.reject();
        }

        return Promise.reject(new Error('Unknown method'));
    };

    return (type: string, params: Record<string, unknown>) => manageAuth(type, params);
};
